import { gql } from "@apollo/client";

export const LIST_DRIVER_CAPACITIES = gql`
    query ListDriverCapacities($driverAccountIds: [Long!]!) {
        listDriverCapacities(driverAccountIds: $driverAccountIds) {
            driverAccountId
            capacityMin
            capacityMax
        }
    }
`;

export interface DriverCapacityItem {
    driverAccountId: number;
    capacityMin: number;
    capacityMax: number;
}

export interface ListDriverCapacitiesResponse {
    listDriverCapacities: DriverCapacityItem[];
}